import React, {Component} from 'react';
import styles from './detailBonusStates.module.scss';

export default class BonusesCanTake extends Component<any, any> {
  props: {
    getPromo: () => void
  }

  render() {
    const {getPromo} = this.props
    return (
      <div className={styles.BonusesCanTake}>
        <div className={styles.BonusesCanTakeImg}>
          <img src="/static/images/icons/bonusesCanTake.svg" alt=""/>
        </div>
        <div className={styles.BonusesCanTakeTitle}>
          <span>Ваш промокод</span>
        </div>
        <div className={styles.BonusesCanTakeText}>
          <span>Бонус можно использовать, пока не истечёт его срок действия. Затем он пропадет.</span>
        </div>
        <button onClick={getPromo} className={styles.BonusesCanTakeBtn}>Получить промокод</button>
      </div>
    )
  }
}
